import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTarget, FiBookOpen, FiStar, FiShield } = FiIcons;

const WhyThisCourse = ({ onBooking }) => {
  const reasons = [
    {
      icon: FiBookOpen,
      title: "ศาสตร์แท้ไม่ใช่ความงมงาย",
      description: "ปาจื้อเป็นศาสตร์จีนโบราณที่มีหลักการชัดเจน ใช้หลักธาตุ 5 องค์ประกอบ และการคำนวณทางคณิตศาสตร์"
    },
    {
      icon: FiTarget,
      title: "เฉพาะเจาะจงด้านการเงิน",
      description: "ไม่ใช่ปาจื้อทั่วไป แต่เน้นการวิเคราะห์และเสริมดวงการเงินโดยเฉพาะ"
    },
    {
      icon: FiStar,
      title: "ได้ยันต์ประจำตัวจริง",
      description: "ไม่ใช่แค่ความรู้ แต่ได้เครื่องมือจริงที่คำนวณเฉพาะสำหรับคุณ"
    },
    {
      icon: FiShield,
      title: "มีหลักการที่พิสูจน์ได้",
      description: "ทุกสิ่งที่สอนมีที่มา มีเหตุผล ไม่ใช่การเดาหรือความเชื่อแบบงมงาย"
    }
  ];

  return (
    <section className="py-16 px-4 bg-slate-800/30">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            ทำไมต้องเป็นหลักสูตรนี้?
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            เพราะเราไม่ได้สอนแค่ทฤษฎี แต่ให้คุณได้เครื่องมือจริงที่ใช้งานได้
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12">
          {reasons.map((reason, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-8 border border-amber-500/20 hover:border-amber-500/40 transition-all duration-300"
            >
              <div className="flex items-start gap-6">
                <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-yellow-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={reason.icon} className="text-white text-xl" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-3">
                    {reason.title}
                  </h3>
                  <p className="text-slate-300 leading-relaxed">
                    {reason.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="text-center"
        >
          <div className="bg-gradient-to-r from-amber-500/20 to-yellow-600/20 rounded-xl p-8 border border-amber-500/30 max-w-4xl mx-auto mb-8">
            <h3 className="text-2xl font-bold text-amber-400 mb-4">
              หลักการสำคัญ
            </h3>
            <p className="text-lg text-white leading-relaxed">
              ปาจื้อไม่ใช่การทำนาย แต่เป็น<span className="text-amber-400 font-semibold">การวิเคราะห์โครงสร้างชะตา</span>
              ผ่านวันเดือนปีเกิด เพื่อหาจุดแข็ง จุดอ่อน และ<span className="text-green-400 font-semibold">ช่วงเวลาที่เหมาะสม</span>
              ในการเสริมด้านการเงิน ซึ่งมีหลักการทางคณิตศาสตร์และดาราศาสตร์รองรับ
            </p>
          </div>

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onBooking}
            className="bg-gradient-to-r from-amber-500 to-yellow-600 text-white px-10 py-4 rounded-full text-lg font-bold shadow-2xl hover:shadow-amber-500/25 transition-all duration-300"
          >
            เริ่มเรียนรู้เดี๋ยวนี้
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyThisCourse;